export default __webpack_public_path__ + "static/media/AllProductItems7.53fd0728.png";